import { IModalStyles } from '@fluentui/react/lib/Modal';
import { IRawStyle, ITheme } from '@fluentui/react/lib/Styling';
import { ContrastColors, CoreColors, DarkColors } from '../teams-colors';
import { ShadowLevels } from '../teams-shadow-levels';
import { teamsBorderRadius } from './constants';

export function getModalStyles(
  themeName: string,
  theme: ITheme
): Partial<IModalStyles> {
  const MODAL_MIN_WIDTH = '400px';
  const MODAL_MIN_HEIGHT = '116px';
  const styles = {
    root: {
      backgroundColor: 'none',
      selectors: {
        '.ms-Overlay': {
          backgroundColor: CoreColors.overlayBackground
        }
      }
    },

    main: {
      backgroundColor: theme.palette.white,
      borderRadius: teamsBorderRadius,
      color: theme.palette.black,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: CoreColors.appBlackAlpha10,
      boxShadow: ShadowLevels.shadowLevel4,
      minWidth: `${MODAL_MIN_WIDTH} !important`,
      minHeight: `${MODAL_MIN_HEIGHT} !important`
    }
  } as Partial<IModalStyles>;

  // Dark theme overrides
  if (themeName === 'dark') {
    ((styles.root as Required<IRawStyle>).selectors[
      '.ms-Overlay'
    ] as IRawStyle).backgroundColor = DarkColors.overlayBackground;

    (styles.main as IRawStyle).backgroundColor = theme.palette.neutralLight;
    (styles.main as IRawStyle).borderColor = theme.palette.white;
  }

  // Contrast theme overrides
  if (themeName === 'contrast') {
    ((styles.root as Required<IRawStyle>).selectors[
      '.ms-Overlay'
    ] as IRawStyle).backgroundColor = ContrastColors.overlayBackground;

    (styles.main as IRawStyle).borderColor = theme.palette.black;
  }
  return styles;
}
